// Env banner + title tag: shown only on non-prod builds (gated by the API base host).
// STAGE => gold hazard stripes + "[STAGE] - " title. LOCAL => purple stripes + "[LOCAL] - " title.
// Prod/dev builds do nothing (no banner, no title change).
export function mountEnvBanner(apiBase) {
  if (!apiBase) return;
  var env = null;
  if (apiBase.indexOf('.stage.moovr.dk') !== -1) {
    env = { word: 'STAGE', tag: '[STAGE] - ', img: '/hazard.png', color: '#2a2000', shadow: 'rgba(255,255,255,.28)' };
  } else if (apiBase.indexOf('.local.moovr.dk') !== -1) {
    env = { word: 'LOCAL', tag: '[LOCAL] - ', img: '/purple.png', color: '#ffffff', shadow: 'rgba(0,0,0,.35)' };
  }
  if (!env) return;

  // --- title prefix (survives dynamic document.title updates, e.g. router hooks) ---
  var applyTitle = function () {
    if (document.title.indexOf(env.tag) !== 0) document.title = env.tag + document.title;
  };
  applyTitle();
  var titleEl = document.querySelector('title');
  if (titleEl && window.MutationObserver) {
    new MutationObserver(applyTitle).observe(titleEl, { childList: true, characterData: true, subtree: true });
  }

  // --- banner ---
  document.documentElement.classList.add('env-banner');
  document.body.classList.add('env-banner');
  var style = document.createElement('style');
  style.textContent =
    'html.env-banner,body.env-banner{height:100%!important;margin:0}' +
    'body.env-banner{padding-top:24px!important;box-sizing:border-box!important}' +
    'body.env-banner #app{position:relative!important;height:100%!important}' +
    '#env-banner{position:fixed;top:0;left:0;right:0;height:24px;z-index:2147483647;overflow:hidden;pointer-events:none;background:url("' + env.img + '") repeat;background-size:auto 24px;box-shadow:0 1px 0 rgba(0,0,0,.25)}' +
    '#env-banner .t{height:24px;line-height:24px;white-space:nowrap;text-align:center;text-transform:uppercase;font:700 12px/24px system-ui,-apple-system,"Segoe UI",Roboto,Arial,sans-serif;letter-spacing:.35em;word-spacing:1.4em;color:' + env.color + ';text-shadow:0 1px 0 ' + env.shadow + ';user-select:none}';
  document.head.appendChild(style);
  var bar = document.createElement('div'); bar.id = 'env-banner';
  var track = document.createElement('div'); track.className = 't';
  var s = ''; for (var i = 0; i < 60; i++) s += env.word + ' ';
  track.textContent = s.trim();
  bar.appendChild(track);
  document.body.appendChild(bar);
}
